<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester semester-nonall ssystem college department sclass keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th>學號-學生姓名</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.StudentNo">
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.StudentNo)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload">
        </Detail>
        <inputmodal id="input" sample="/template/other.xlsx" url="/api/scholarshipdetail/OtherExcel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './otherDetail.vue';

    import { master } from '@/views';
    export default master({
        name: 'other',
        api: '/api/scholarship/',
        components: { Detail }
    });
</script>

<style>
</style>